module.exports = __webpack_public_path__ + "static/img/kof15-logo.c838ea5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/kof15-logo.png
// module id = 3RTx
// module chunks = 0